// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_wBhzJ","g-empty-place":"g-empty-place"};